import { EnvType } from "../services";
import ApiClient from "../api-client";
import ISupportApiClient from "../Support/support-api-client";
import SupportApiClient from "../Support/support-api-client";
import { GenericResponseStd } from "../Types/generic-response-std";
import { FormDataZendeskTicketRequest } from "../Types/form-data-ticket-zendesk-request";
import { GetFormFieldsResponse } from "../Types/get-form-fields-response";
import { GetIsAlreadyReportedResponse } from "../Types/get-issue-already-reported-response";
import { GetTokenResponse } from "../Types/get-token-response";
import { GetTokenRequest } from "../Types/get-token-request";

export default class SupportService {
  supportApiClient: ISupportApiClient;

  constructor(envType: EnvType) {
    this.supportApiClient = new SupportApiClient(new ApiClient(envType), envType);
  }

  async CreateZendeskIssue(request: FormDataZendeskTicketRequest, file: File | undefined): Promise<GenericResponseStd> {
    return await this.supportApiClient.CreateZendeskIssue(request, file);
  }
  async GenerateZendeskToken(request: GetTokenRequest): Promise<GetTokenResponse> {
    return await this.supportApiClient.GenerateZendeskToken(request);
  }
  async GetZendeskFormFields(): Promise<GetFormFieldsResponse> {
    return await this.supportApiClient.GetZendeskFormFields();
  }
  async GetIssueAlreadyReported(typology: string, objectId: number): Promise<GetIsAlreadyReportedResponse> {
    return await this.supportApiClient.GetIssueAlreadyReported(typology, objectId);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.supportApiClient.GetApiUrl();
  }
}
